import React, { useState, useEffect} from 'react';
import styled from 'styled-components';
import { Button } from '../styles/Button';
import { NavLink,useNavigate, useParams } from 'react-router-dom';
import toast,{Toaster} from 'react-hot-toast';
import AdminMenu from './AdminMenu';
import PageHeader from "../components/PageCloseButton";
import { toTitleCase, normalize, normalizeNoSpaces } from "../Helpers/stringTitlecase.js";


//========================== To add a protected Route that only admins can access this page================

// const API="http://localhost:8080/api/products";
const API=`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`;

const EditProductForm = () => {

const navigate=useNavigate();
const { id } = useParams();

  const [productData, setProductData] = useState({
    category: '',
    subcategory: '',
    Item: '',
    SKU: '',
    name:'',
    finish:'',
    HSCode:'',
    featured:'',
    packing: '',
    type:'',
    size: {length:'',width:'',height:''},
    wallDistance: '',
    outletDia: '',
    TapHole:'',    
    OverFlow:'',   
    weight: '',
    price: '',
    star: '',
    Feature: '',
    main: '',
    featureImage:{}
  });

useEffect(() => {
 const fetchProduct = async () => {
//    console.log("🟢 fetchProduct called with ID:", id);
//  console.log("📡 Attempting to fetch:", `${API}/id/${id}`);
 
   try {
     const response = await fetch(`${API}/${id}`);
       
     if (!response.ok) throw new Error("Product not found");
     const product = await response.json();
    //  console.log("Fetched product:", product);

    //  console.log("Fetched Product from API:", product); //👈 Add this line
    setProductData(product);
  } catch (error) {
    // console.error("Error fetching product:", error);
    toast.error("Failed to load product");
  }
};
fetchProduct();
   }, [id]);


  const handleChange = (e) => {
  const { id, type, checked, value } = e.target;
  const formattedValue = type === "checkbox" ? checked : toTitleCase(value);
  
  if (id.includes(".")) {
    const [parent, child] = id.split(".");
    setProductData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [child]: formattedValue,
      },
    }));
  } else {
    setProductData((prev) => ({
      ...prev,
      [id]: formattedValue,
    }));
  }
  };
   
     const [updatedImages, setUpdatedImages] = useState({});
    //  const [previewImages, setPreviewImages] = useState({});
    const handleImageChange = (e) => {
   const { id, files } = e.target;
   if (files && files[0]) {
     const file = files[0];


     if (file.size > 2 * 1024 * 1024) {
       toast.error("Image too large. Max 2MB.");
       return;
     }

 
     const previewURL = URL.createObjectURL(file);


     // ✅ Save preview
     setPreviewImages((prev) => ({
       ...prev,
       [id]: previewURL,
     }));


     // ✅ Save actual file
     setUpdatedImages((prev) => ({
       ...prev,
       [id]: file,
     }));
   }
  };

 
  const [selectedFile, setSelectedFile] = useState(null); // ✅ for main image upload
  const [previewMainImage, setPreviewMainImage] = useState(null); // ✅ for main preview

  const [featureFiles, setFeatureFiles] = useState({}); // ✅ renamed for clarity
  const [previewImages, setPreviewImages] = useState({});
     

 
// // ✅ Main image upload handler
const handleMainImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setSelectedFile(file);
    const preview = URL.createObjectURL(file);
    setPreviewMainImage(preview); // for preview
  }
};
 const updateProduct = async () => {
  try {
    const formData = new FormData();

    // Append text fields
    for (const key in productData) {
      if (key === "size") {
        formData.append("size", JSON.stringify(productData.size));
      } else if (key === "featureImage") {
        formData.append("featureImage", JSON.stringify(productData.featureImage));
      }else if (key === "category" || key === "subcategory") {
    // ❌ skip these, handled separately below
    continue;
  }else {
        formData.append(key, productData[key] ?? "");
      }
    }
    // ✅ Always send IDs, not labels
  if (productData.category?._id) {
      formData.append("category", productData.category._id);
      }
  if (productData.subcategory?._id) {
      formData.append("subcategory", productData.subcategory._id);
      }

    // Append main image if selected
  if (selectedFile) {
      formData.append("main", selectedFile);
      }

    // Append updated feature images
      Object.entries(updatedImages).forEach(([field, file]) => {
      formData.append(field, file);
      });

    // ✅ Debug: log everything before sending
// for (let [key, value] of formData.entries()) {
//   console.log(key, value);
// }


    const response = await fetch(`${API}/updateproduct/${productData._id}`, {
      method: "PUT",
      body: formData,
    });

    if (!response.ok) {
        toast.error("Could not update product");
      return;
    }

    const result = await response.json();
    toast.success("Product updated!");
    navigate("/adminproduct");
  } catch (error) {
    toast.error("Update error");
  }
};


  return (
  <Wrapper>
    <Toaster position='top-center' reverseOrder={false}></Toaster>
    <div className="grid grid-two-column">
      <AdminMenu/>
      <div className="main-container">
        <PageHeader title="Update Product" />       
        <form autoComplete="off">           
           <div className="product-container">
              <div className="product-details">
                  <h3>Product Attributes</h3>
                    <label htmlFor="category">Category</label>
                      <input id="category" 
                      value={productData.category?.label}
                      onChange={handleChange} 
                      placeholder="Category" 
                      />
                    
                    <label htmlFor="subcategory">Sub-Category</label>
                      <input
                      type="text"
                      id="subcategory"
                      value={productData.subcategory?.label} 
                      onChange={handleChange}
                      placeholder="sub-Category"
                      />

                    <label htmlFor="Item">Item</label>
                      <input
                      type="text"
                      id="Item"
                      value={productData.Item} 
                      onChange={handleChange}
                      placeholder="Item"
                      />

                    <label htmlFor="SKU">SKU</label>
                      <input
                      type="text"
                      id="SKU"
                      value={productData.SKU} 
                      onChange={handleChange}
                      placeholder="SKU"
                      />

                    <label htmlFor="name">Name</label>
                      <input
                      type="text"
                      id="name"
                      value={productData.name} 
                      onChange={handleChange}
                      placeholder="Name"
                      style={{ textTransform: "uppercase" }}
                      />

                    <label htmlFor="finish">Finish</label>
                      <input
                      type="text"
                      id="finish"
                      value={productData.finish} 
                      onChange={handleChange}
                      placeholder="Finish"
                      />

                    <label htmlFor="HSCode">H.S.Code</label>
                      <input
                      type="text"
                      id="HSCode"
                      value={productData.HSCode} 
                      onChange={handleChange}
                      placeholder="H.S.Code"
                      />

                    <label htmlFor="packing">Packing</label>
                      <input
                      type="text"
                      id="packing"
                      value={productData.packing} 
                      onChange={handleChange}
                      placeholder="Packing"
                      />

                    <label htmlFor="price">Price</label>
                      <input
                      type="text"
                      id="price"
                      value={productData.price} 
                      onChange={handleChange}
                      placeholder="price"
                      />
                    <label htmlFor="star">Star</label>
                      <input
                      type="text"
                      id="star"
                      value={productData.star} 
                      onChange={handleChange}
                      placeholder="star"
                      />
                    
                    <label htmlFor="featured" className="featured-label">
                      Featured:
                      <input
                      type="checkbox"
                      id="featured"
                      checked={productData.featured}
                      onChange={handleChange}
                      />
                      <span className="featured-value">
                        {productData.featured ? "True" : "False"}
                      </span>
                    </label>

                    <label htmlFor="isDeleted" className="featured-label">
                      isDeleted:
                      <input
                      type="checkbox"
                      id="isDeleted"
                      checked={productData.isDeleted}
                      onChange={handleChange}
                      />
                     <span className="featured-value">
                        {productData.isDeleted ? "True" : "False"}
                      </span>
                  </label>
              </div>

              <div className="product-details">
                  <h3>Product Key Features</h3>
                  
                  <label htmlFor="type">Type</label>
                      <input
                      type="text"
                      id="type"
                      value={productData.type} 
                      onChange={handleChange}
                      placeholder="Installation Type"
                      />

                  <label htmlFor="size-array">Size</label>
                    {/* <input
                      type="text"
                      id="size"
                      value={productData.size} 
                      onChange={handleChange}
                      placeholder="length X height X width"
                      /> */}

                  <label htmlFor="length">Length</label>
                    <input
                    type="number"
                    id="length"
                    value={productData.size?.length || ""}
                    onChange={(e) =>
                    setProductData((prev) => ({
                     ...prev,
                    size: { ...prev.size, length: e.target.value }
                    }))
                    }
                    />

                  <label htmlFor="width">Width</label>
                    <input
                    type="number"
                    id="width"
                    value={productData.size?.width || ""}
                    onChange={(e) =>
                    setProductData((prev) => ({
                     ...prev,
                    size: { ...prev.size, width: e.target.value }
                    }))
                    }
                    />

                  <label htmlFor="height">Height</label>
                    <input
                    type="number"
                    id="height"
                    value={productData.size?.height || ""}
                    onChange={(e) =>
                    setProductData((prev) => ({
                     ...prev,
                    size: { ...prev.size, height: e.target.value }
                    }))
                    }
                    />


                  <label htmlFor="size-array">Wall Distance</label>
                    <input
                    type="text"
                    id="wallDistance"
                    value={productData.wallDistance} 
                    onChange={handleChange}
                    placeholder="Wall Distance"
                    />

                  <label htmlFor="size-array">Outlet Dia</label>
                    <input
                    type="text"
                    id="outletDia"
                    value={productData.outletDia} 
                    onChange={handleChange}
                    placeholder="Outlet Dia"
                    />

                  <label htmlFor="size-array">Tap Hole</label>
                    <input
                    type="text"
                    id="TapHole"
                    value={productData.TapHole} 
                    onChange={handleChange}
                    placeholder="Tap Hole"
                    />

                  <label htmlFor="size-array">OverFlow</label>
                    <input
                    type="text"
                    id="OverFlow"
                    value={productData.OverFlow} 
                    onChange={handleChange}
                    placeholder="OverFlow"
                    />

                  <label htmlFor="weight">Weight</label>
                    <input
                    type="text"
                    id="weight"
                    value={productData.weight} 
                    onChange={handleChange}
                    placeholder="weight"
                    />
                      
                  <label htmlFor="Feature">Feature</label>
                    <input
                    type="text"
                    id="Feature"
                    value={productData.Feature} 
                    onChange={handleChange}
                    placeholder="Feature"
                    />
              </div>

              <div className="product-details">
                <h3>Image</h3>

                  <div className="image-array">
                      <label htmlFor="image">main</label>
                      <input
                      type="file"
                      id="main"
                      accept="image/*" onChange={handleMainImageChange}
                      />
                      <input
                          type="text"
                          readOnly
                          value={previewMainImage ? previewMainImage:productData.main}
                          style={{ fontSize: "0.8rem", marginTop: "5px" }}
                         />
                      <img src={previewMainImage||productData.main} alt="main Preview" width={100}/>
                  </div>
                      <div className="image-array">
                      <label htmlFor="featureImage.front">Front</label>
                      <input
                      type="file"
                      id="front"
                      accept="image/*" onChange={handleImageChange}
                      />
                      <input
                          type="text"
                          readOnly
                          value={previewImages.front ? previewImages.front:productData.featureImage?.front}
                          style={{ fontSize: "0.8rem", marginTop: "5px" }}
                         />
                      <img src={previewImages.front||productData.featureImage?.front} alt="Front Preview" width={100}/>
                  </div>
                  <div className="image-array">
                        <label htmlFor="featureImage.back">Back</label>
                        <input
                        type="file"
                        id="back"
                        accept="image/*" onChange={handleImageChange}
                        />
                        <input
                          type="text"
                          readOnly
                          value={previewImages.back ? previewImages.back:productData.featureImage?.back}
                          style={{ fontSize: "0.8rem", marginTop: "5px" }}
                         />
                        <img src={previewImages.back||productData.featureImage?.back} alt="back Preview" width={100}/>
                  </div>
                  <div className="image-array">
                      <label htmlFor="featureImage.side">Side</label>
                      <input
                      type="file"
                      id="side"
                      accept="image/*" onChange={handleImageChange}
                      />
                      <input
                          type="text"
                          readOnly
                          value={previewImages.side ? previewImages.side:productData.featureImage?.side}
                          style={{ fontSize: "0.8rem", marginTop: "5px" }}
                         />
                      <img src={previewImages.side||productData.featureImage?.side } alt="side Preview" width={100}/>
                   </div>
                  <div className="image-array">
                        <label htmlFor="featureImage.top">Top</label>
                        <input
                        type="file"
                        id="top"
                        accept="image/*" onChange={handleImageChange}
                        />
                        <input
                          type="text"
                          readOnly
                          value={previewImages.top ? previewImages.top:productData.featureImage?.top}
                          style={{ fontSize: "0.8rem", marginTop: "5px" }}
                         />
                        <img src={previewImages.top||productData.featureImage?.top } alt="top Preview" width={100}/>
                  </div>
                  <div className="image-array">
                        <label htmlFor="featureImage.bottom">Bottom</label>
                        <input
                        type="file"
                        id="bottom"
                        accept="image/*" onChange={handleImageChange}
                        />
                        <input
                          type="text"
                          readOnly
                          value={previewImages.bottom ? previewImages.bottom:productData.featureImage?.bottom}
                          style={{ fontSize: "0.8rem", marginTop: "5px" }}
                         />
                        <img src={previewImages.bottom||productData.featureImage?.bottom } alt="bottom Preview" width={100}/>
                  </div>
                  <div className="image-array">
                        <label htmlFor="featureImage.packaging ">Packaging</label>
                        <input
                        type="file"
                        id="packaging"
                        accept="image/*" onChange={handleImageChange}
                        />
                        <input
                          type="text"
                          readOnly
                          value={previewImages.packaging? previewImages.packaging:productData.featureImage?.packaging}
                          style={{ fontSize: "0.8rem", marginTop: "5px" }}
                         />
                        <img src={previewImages.packaging||productData.featureImage?.packaging} alt="Packaging Preview" width={100}/>
                  </div>
              
              </div>
           </div>
            <NavLink  to='/products'>
           <div className="two-button">
                
                <Button className="btn btn-two" type="button">
                Cancel
                </Button>
                
                <Button type="submit" onClick={() => updateProduct(productData)}>
                  Update
                </Button>
                
            </div>
            </NavLink>
        </form>
      </div>
    </div>
  </Wrapper>
  );
};


const Wrapper = styled.section`
background: #fff;
justify-content: center;

.grid-two-column{
    display: grid;
    grid-template-columns: 2fr 8fr; 
    gap: 2rem;
    }

.main-container{
    padding: 2rem;   
   }
 
.product-container{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap:3rem;
    margin: 3rem auto;
    padding:2rem;
    border-radius: 1rem;
    background-color:${({ theme }) => theme.colors.bg};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }

img {
    margin-top: 10px;
    border-radius: 8px;
    }
    
.featured-label {
    display: flex;
    align-items: center;
    align-text: center;
    margin-top: 2rem;
    gap: 2rem;
    font-size: 12px;
    }

.featured-label input[type="checkbox"] {
      width: 2.5rem;
      height: 2.5rem;
      accent-color: #007bff; /* modern browsers */
      cursor: pointer;
    }

.featured-value {
    font-weight: 600;
    color: #007bff;
    font-size: 15px;
    }

.two-button Button{
    margin: 1rem;
    width : 12rem;
  } 
      
@media (max-width: ${({ theme }) => theme.media.mobile}){
  
  .grid-two-column{
    grid-template-columns:1fr; 
    }
  
  .container {
    padding:1rem;
    }
  
  .product-container{
    display:block;
    margin:1rem;
    padding:1rem;
    }
  
  .product-details{
   margin: 2rem;
  } 
   
  .two-button Button{
    width:10rem;
    }
 }  
}
`;


export default EditProductForm;
